import React from 'react'
import { Button } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import styles from '../forms.module.scss';

export default function CustomToggle({ children, eventKey, isComplete, handleClick, onClick, disabled }) {
  const decoratedOnClick = useAccordionButton(`${eventKey}`, () => {
    if (eventKey == "1") {
      //we can customize
    }
  })

  const click = (key) => {
    if (onClick) {
      onClick(key);
    }

    if (handleClick) {
      return handleClick(key);
    }

    return decoratedOnClick();
  }

  const renderButton = () => {
    if (isComplete) {
      return (
        <Button className={styles.actionButton}
          onClick={() => click(eventKey + 1)}
          size="sm"
          variant="primary"
          disabled={disabled}
        >
          {children}
        </Button>
      )
    }

    return (
      < button
        type="button"
        onClick={() => click(eventKey)}
      >
        {children}
      </button >
    );
  }

  return renderButton();
}